var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
const LegendHeader = (_a) => {
    var { text, size, textProps, backgroundProps } = _a, props = __rest(_a, ["text", "size", "textProps", "backgroundProps"]);
    return (React.createElement("g", Object.assign({}, props),
        React.createElement("rect", Object.assign({ width: size.width, height: size.height, fill: "#555555", fillOpacity: 0.8 }, backgroundProps)),
        React.createElement("text", Object.assign({ x: size.width * 0.05, y: size.height * 0.5, width: size.width * 0.9, height: size.height * 0.8, dominantBaseline: "middle", fontSize: size.height * 0.6 + "px", fontWeight: "bold", fill: "#ffffff" }, textProps), text)));
};
export default LegendHeader;
